var _path, _g, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconPass = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "icon-pass_svg__a",
  width: 20,
  height: 20,
  x: 5,
  y: 5,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M5 5h20v20H5V5Z",
  clipRule: "evenodd"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#icon-pass_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#4264FD",
  fillRule: "evenodd",
  d: "M10.664 6.5C8.134 6.5 6.5 8.231 6.5 10.914v8.168c0 2.683 1.635 4.416 4.164 4.416h8.668c2.532 0 4.168-1.733 4.168-4.416v-8.168c0-2.683-1.636-4.416-4.166-4.416h-8.67ZM19.332 25h-8.668C7.276 25 5 22.622 5 19.084v-8.168C5 7.378 7.276 5 10.664 5h8.67C22.724 5 25 7.378 25 10.916v8.168C25 22.622 22.723 25 19.332 25Z",
  clipRule: "evenodd"
}))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#4264FD",
  fillRule: "evenodd",
  d: "M11.839 13.898a1.103 1.103 0 0 0-.002 2.204c.607 0 1.102-.494 1.102-1.102 0-.607-.494-1.1-1.1-1.102Zm-.002 3.704A2.605 2.605 0 0 1 9.235 15a2.605 2.605 0 0 1 2.602-2.602A2.605 2.605 0 0 1 14.439 15a2.605 2.605 0 0 1-2.602 2.602Z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#4264FD",
  fillRule: "evenodd",
  d: "M20.01 17.602a.75.75 0 0 1-.75-.75V15.75h-5.568a.75.75 0 1 1 0-1.5h6.318a.75.75 0 0 1 .75.75v1.853a.75.75 0 0 1-.75.75Z",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#4264FD",
  fillRule: "evenodd",
  d: "M17.181 17.602a.75.75 0 0 1-.75-.75V15a.75.75 0 0 1 1.5 0v1.853a.75.75 0 0 1-.75.75Z",
  clipRule: "evenodd"
})));
export default SvgIconPass;